module.exports = __webpack_public_path__ + "static/AlishaCircle-7b553154e2eb106ff8d35bd3d919b38c.png";